import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SpanMaintenanceApiService } from '../../../../../../modules/api/span-maintenance-api.service';

@Component({
    templateUrl: './add-span-modal.template.html'
})
export class AddSpanModalComponent {

    loading = false;

    form: UntypedFormGroup = new UntypedFormGroup({
        span: new UntypedFormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern(/^[a-zA-Z0-9_]*$/)]),
        conceptWeeks: new UntypedFormControl(0, [Validators.min(-99), Validators.max(99)]),
        designWeeks: new UntypedFormControl(0, [Validators.min(-99), Validators.max(99)]),
        buildWeeks: new UntypedFormControl(0, [Validators.min(-99), Validators.max(99)]),
        conceptBuffer: new UntypedFormControl(0, [Validators.min(-99), Validators.max(99)]),
        designBuffer: new UntypedFormControl(0, [Validators.min(-99), Validators.max(99)]),
        buildBuffer: new UntypedFormControl(0, [Validators.min(-99), Validators.max(99)]),
        examples1: new UntypedFormControl('', Validators.maxLength(150)),
        examples2: new UntypedFormControl('', Validators.maxLength(150)),
        examples3: new UntypedFormControl('', Validators.maxLength(150)),
        mathUnits: new UntypedFormControl('', Validators.maxLength(10)),
        active: new UntypedFormControl(true)
    });

    constructor(
        private readonly dialogRef: MatDialogRef<AddSpanModalComponent>,
        private readonly spanMaintenanceApiService: SpanMaintenanceApiService,
        private readonly toastr: ToastrService
    ) { }

    onSaveClick() {
        this.loading = true;

        this.spanMaintenanceApiService.createSpan(this.form.value)
            .pipe(finalize(() => this.loading = false))
            .subscribe(response => this.dialogRef.close(response));
    }
}
